import React from 'react';
import type { FormFichaAtivo } from './ativoFicha.form';

interface AtivoCompraCamposProps {
  form: FormFichaAtivo;
  onChange: (campo: keyof FormFichaAtivo, valor: string) => void;
}

/** Aba "Compra" da ficha — separada porque é pouco usada (só pra consultar/comparar com
 * compras futuras) e não precisa poluir a aba principal. Tudo opcional. */
export default function AtivoCompraCampos({ form, onChange }: AtivoCompraCamposProps) {
  return (
    <section className="grid gap-3 sm:grid-cols-2">
      <p className="text-sm text-gray-500 sm:col-span-2">Tudo opcional — preencha quando tiver a informação.</p>
      <div>
        <label className="block text-sm font-medium text-gray-700">Data de compra</label>
        <input type="date" className="input-primary mt-1 w-full" value={form.dataCompra} onChange={(e) => onChange('dataCompra', e.target.value)} />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Nº da nota fiscal</label>
        <input className="input-primary mt-1 w-full" value={form.notaFiscalNumero} onChange={(e) => onChange('notaFiscalNumero', e.target.value)} />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Fornecedor</label>
        <input className="input-primary mt-1 w-full" value={form.fornecedor} onChange={(e) => onChange('fornecedor', e.target.value)} />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Valor (R$)</label>
        <input
          className="input-primary mt-1 w-full"
          inputMode="decimal"
          placeholder="Ex.: 3.500,00"
          value={form.valor}
          onChange={(e) => onChange('valor', e.target.value)}
        />
      </div>
    </section>
  );
}
